import React from "react";
import { useNavigate } from "react-router-dom";
import { ImageIcon, Rocket } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

export function ProductCard({ item, promoted }) {
  const navigate = useNavigate();
  const { t } = useT();
  const hasDiscount = (item.discount_percent || 0) > 0;
  const discountedPrice = hasDiscount
    ? item.price * (1 - (item.discount_percent || 0) / 100)
    : item.price;

  return (
    <button
      data-testid={`product-card-${item.product_id}`}
      onClick={() => navigate(`/product/${item.product_id}`)}
      className="group text-start bg-white rounded-2xl overflow-hidden brand-shadow-sm hover:brand-shadow-md transition-all duration-300 hover:-translate-y-1 w-full"
    >
      <div className="relative h-40 sm:h-44 bg-[#F7F8FE] flex items-center justify-center overflow-hidden">
        {item.image_base64 ? (
          <img src={item.image_base64} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <ImageIcon size={30} className="text-[#9CA3AF]" />
        )}
        {promoted && (
          <span className="absolute top-2 end-2 flex items-center gap-1 bg-[#FF8A3C] text-white text-[10px] font-black px-2 py-0.5 rounded-lg">
            <Rocket size={10} /> {t("promoted_badge")}
          </span>
        )}
        {hasDiscount && (
          <span className="absolute bottom-2 end-2 bg-[#00D26A] text-white text-[11px] font-black px-2 py-0.5 rounded-lg">
            -{item.discount_percent}%
          </span>
        )}
        {item.quantity === 0 && (
          <span className="absolute top-2 start-2 bg-[#FF3D5A] text-white text-[10px] font-black px-2 py-0.5 rounded-lg">
            {t("out_of_stock")}
          </span>
        )}
      </div>
      <div className="p-3">
        <p className="text-sm font-extrabold text-[#161629] truncate">{item.name}</p>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-sm font-black text-[#FF3D5A]">{discountedPrice.toFixed(2)} {t("currency_lyd")}</span>
          {hasDiscount && <span className="text-xs text-[#9CA3AF] line-through font-bold">{item.price.toFixed(0)}</span>}
        </div>
        {item.seller_name && <p className="text-[11px] text-[#6B7280] mt-1 truncate">{item.seller_name}</p>}
      </div>
    </button>
  );
}
